import { useClientTranslation } from "@/modules/App/components/i18n/i18n.client"
import { LinkButton } from "@dalmatech/ui"
import { ArrowLeft } from "lucide-react"

import * as styles from "./back-button.styled"
import { usePrevious } from "@/shared/hooks/use-router"

export const BackButton = () => {
  const { t } = useClientTranslation("global", {
    keyPrefix: "navbar",
  })
  const goToPreviousPage = usePrevious()

  return (
    <LinkButton onClick={goToPreviousPage} LeftIcon={<ArrowLeft className={styles.icon} />}>
      {t("back")}
    </LinkButton>
  )
}
